<template>
    <div :ref="refName" class="rent-select-landing"  @click="clickEvent" @mouseenter="changeArrow(1)" @mouseleave="changeArrow()">
        <span :style="{color: selectColor}" >
            {{selectText}}
            <img class="arrow" :style="{transform: 'rotate('+arrowRotate+'deg)'}" :src="arrowImg" />
        </span>
        <slot v-if="show"></slot>
    </div>
</template>
<script>
export default {
    data () {
        return {
            show: 0,
            selectColor: '#c5c2c1',
            arrowImg: require('@/assets/img/icon/arrow_down_gray.svg'),
            arrowRotate: '0',
            selectText: this.selectMsg,
            isChange: 0
        }
    },
    props: {
        selectMsg: {
            type: String,
            default: '請選擇'
        },
        refName: String,
        setDefault: Boolean
    },
    watch: {
        // selectText: function () {
        // },
        selectMsg: function (val) {
            if(val){
                // this.selectColor = '#676362'
                this.selectText = val
            }
        },
        setDefault: function () {
            if(this.setDefault){
                this.selectText = this.selectMsg
                this.isChange = 0
                this.selectColor = '#c5c2c1'
                this.changeArrow()
            }
        }
    },
    mounted () {
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            // console.log(e.target != el)
            if( el.contains(e.target) != true){
                _this.dropUp();
                _this.changeArrow()
                if( _this.isChange == 0 ){
                    _this.selectColor = '#c5c2c1'
                }
            }
        })
    },
    methods: {
        dropDown: function () {
            this.show = 1;
        },
        dropUp: function () {
            this.show = 0;
        },
        changeArrow: function (color, rotate) {
            if( color == 1 ){
                this.arrowImg = require('@/assets/img/icon/arrow_down_black.svg')
            }else{
                if(this.show == 1 || this.isChange ==1){
                    this.arrowImg = require('@/assets/img/icon/arrow_down_black.svg')
                }else{
                    this.arrowImg = require('@/assets/img/icon/arrow_down_gray.svg')
                }
            }
            if( rotate == 1 ){
                this.arrowRotate = 180
            }else{
                if(this.show == 1){
                    this.arrowRotate = 180
                }else{
                    this.arrowRotate = 0
                }
                
            }
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
                this.isChange = 1
                this.changeArrow()
                
                this.selectText = event.target.innerText.replace(/(<br[^>]*>|\s*)/g,'');
                let data = {
                    id: event.target.dataset.id,
                    name: event.target.dataset.name,
                    ref: this.refName
                };
                this.$emit('getId', data);
            }else{
                this.dropDown()
                this.changeArrow(1, 1)
                this.selectColor = '#676362'
            }
        }
    }
}
</script>
<style   lang="scss">
    .rent-select-landing{
        position: relative;
        padding: 0px 16px;
        border: solid 2px #d7d7d7;
        border-radius: 8px;
        height: 48px;
        font-size: 16px;
        box-sizing: border-box;
        cursor: pointer;
        &.error{
            border: solid 2px #ff6868 !important;
        }
        &:hover{
            border: 2px solid #676362;
            span{
                color: #c5c2c1;
            }
        }
        span{
            display: block;
            height: 100%;
            display: flex;
            align-items: center;
            color: #c5c2c1;
            // padding: 5px 10px;
            .arrow{
                position: absolute;
                right: 8px;
            }
        }
        ul{
            position: absolute;
            // display: none; 
            width: 100%;
            padding: 4px 0;
            border-radius: 4px;
            z-index: 6;
            left: -2px;
            top: 47px;
            box-shadow: 0 2px 8px 0 rgba(41, 38, 37, 0.16);
            background-color: #ffffff;
            li{
                position: relative;
                padding: 12px 16px;
                cursor: pointer;
                
            }
            li:hover{
                background: #fff9f1;

            }
            .road-filter{
                padding: 12px 16px;
                .search{
                    position: absolute;
                    top: 26px;
                    left: 28px;
                }
                input{
                    padding-left: 38px;
                    width: 112px;
                }
            }
            .create-tips{
                display: flex;
                align-items: center;
                color: #3942b5;
                padding: 7px 16px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/widges/input/RentSelect.vue